// extracted by mini-css-extract-plugin
export default {"blogCard":"blog_blogCard__YDyR-","share":"blog_share__Qan1M","facebook":"blog_facebook__ibZu1","twitter":"blog_twitter__q9SrL"};